import { useMemo, useCallback } from 'react';

/**
 * Custom hook to manage gateway event filters
 *
 * @param {Object} filters - Current filter state
 * @param {Function} setFilters - Function to update filters
 * @param {Function} resetFilters - Function to reset filters
 * @returns {Object} Filter utilities and handlers
 */
export const useGatewayEventFilters = (filters, setFilters, resetFilters) => {
    // Check if filters have search values for enabling reset button
    const hasSearchFilters = useMemo(() => {
        return !!(
            filters?.eventName?.trim() ||
            filters?.gatewaySerialNumber?.trim() ||
            filters?.dcuSerialNumber?.trim() ||
            filters?.organizationId !== null && filters?.organizationId !== undefined ||
            filters?.userEmail?.trim() ||
            filters?.eventTypes && filters?.eventTypes?.length > 0
        );
    }, [filters?.eventName, filters?.gatewaySerialNumber, filters?.dcuSerialNumber, filters?.organizationId, filters?.userEmail, filters?.eventTypes]);

    // Text search fields for debouncing
    const textSearchFields = useMemo(() => [
        filters?.eventName,
        filters?.gatewaySerialNumber,
        filters?.dcuSerialNumber,
        filters?.userEmail
    ], [filters?.eventName, filters?.gatewaySerialNumber, filters?.dcuSerialNumber, filters?.userEmail]);

    // Handle search field changes
    const handleSearchFieldChange = useCallback((field, value) => {
        setFilters({ [field]: value });
    }, [setFilters]);

    // Handle date selection
    const handleSelectDate = useCallback((from, to) => {
        if (from && to) {
            setFilters({
                ...filters,
                dateSelection: { from, to }
            });
        }
    }, [filters, setFilters]);

    return {
        hasSearchFilters,
        textSearchFields,
        handleSearchFieldChange,
        handleSelectDate,
        resetFilters
    };
};
